<!--
 * @Author: hujp
 * @LastEditors: hujp
 * @Description: 多语言组件插值
-->

<!--
    使用说明：
        en.json
            "test_tip":"输入测试ARC ID和Key，验证<$0>ARC身份</$0>后即可入住<$1>Hik-ProConnect</$1>",

        test.vue
            <t lang='test_tip' tag?='span'>
                <b></b>
                <a style="color:red" href="#/"></a>
            </t>

        output
            <span>输入测试ARC ID和Key，验证<b>ARC身份</b>后即可入住<a style="color:red" href="#/">Hik-ProConnect</a><span>

    限制：
        1.翻译文件(.json)中的插槽数(<$0>)必须小于等于模板文件(.vue)中的插槽数(slot)
        2.暂不支持嵌套插槽
-->

<script>
/* eslint-disable no-use-before-define */
/* eslint-disable no-undefined */
export default {
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    lang: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 将多语言翻译后的结果拆解为text/slot节点
    getChildrenArr() {
      const strValue = this.$t(this.lang);
      const REGEXP = /<\$\d>(.*?)<\/\$\d>/g;
      // const markTxtArr = Array.from(strValue.matchAll(REGEXP));
      const markTxtArr = [];
      let match;
      while ((match = REGEXP.exec(strValue)) !== null) {
        markTxtArr.push(match);
      }
      if (markTxtArr.length > 0) {
        let curIndex = 0;
        let children = [];
        markTxtArr.forEach((markTxt, index) => {
          children.push({
            type: 'text',
            value: strValue.slice(curIndex, markTxt.index)
          });
          children.push({
            type: 'slot',
            value: markTxt[1]
          });
          curIndex = markTxt.index + markTxt[0].length;

          if (index + 1 === markTxtArr.length) {
            children.push({
              type: 'text',
              value: strValue.slice(curIndex)
            });
          }
        });
        return children;
      }
      return [];
    },
    // 替换slot的子节点为翻译后的文本
    replaceSlotChild(vnode, child) {
      let cloned = new VNode(
        vnode.tag,
        vnode.data,
        [new VNode(undefined, undefined, undefined, String(child.value))],
        vnode.text,
        vnode.elm,
        vnode.context,
        vnode.componentOptions,
        vnode.asyncFactory
      );
      cloned.ns = vnode.ns;
      cloned.isStatic = vnode.isStatic;
      cloned.key = vnode.key;
      cloned.isComment = vnode.isComment;
      cloned.fnContext = vnode.fnContext;
      cloned.fnOptions = vnode.fnOptions;
      cloned.fnScopeId = vnode.fnScopeId;
      cloned.asyncMeta = vnode.asyncMeta;
      return cloned;
    }
  },
  render(h) {
    let curIndex = 0;
    const slots = this.$slots.default;
    const REGEXP = /<\$\d>(.+?)<\/\$\d>/g;
    // const langSlots = Array.from(this.$t(this.lang).matchAll(/<\$\d>(.+?)<\/\$\d>/g));
    const langSlots = [];
    let match;
    while ((match = REGEXP.exec(this.$t(this.lang))) !== null) {
      langSlots.push(match);
    }
    // 页面提供的slots数量少于多语言中需要的插槽数
    if (slots.length < langSlots.length) {
      // eslint-disable-next-line no-console
      console.error('slots num doesn`t match');
      return h(this.tag, this.$t(this.lang));
    }
    return h(
      this.tag,
      {
        attrs: {
          title: this.$t(this.lang).replace(/<(\/)?\$\d>/g, '')
        }
      },
      this.getChildrenArr().map((child) => {
        if (child.type === 'text') {
          return child.value;
        } else if (child.type === 'slot') {
          const vnode = this.$slots.default[curIndex++];
          return this.replaceSlotChild(vnode, child);
        }
        return false;
      })
    );
  }
};

// copy from Vue VNode
class VNode {
  constructor(
    tag,
    data,
    children,
    text,
    elm,
    context,
    componentOptions,
    asyncFactory
  ) {
    this.tag = tag;
    this.data = data;
    this.children = children;
    this.text = text;
    this.elm = elm;
    this.ns = undefined;
    this.context = context;
    this.fnContext = undefined;
    this.fnOptions = undefined;
    this.fnScopeId = undefined;
    this.key = data && data.key;
    this.componentOptions = componentOptions;
    this.componentInstance = undefined;
    this.parent = undefined;
    this.raw = false;
    this.isStatic = false;
    this.isRootInsert = true;
    this.isComment = false;
    this.isCloned = false;
    this.isOnce = false;
    this.asyncFactory = asyncFactory;
    this.asyncMeta = undefined;
    this.isAsyncPlaceholder = false;
  }

  // DEPRECATED: alias for componentInstance for backwards compat.
  /* istanbul ignore next */
  get child() {
    return this.componentInstance;
  }
}
</script>
